import LookupContentTypeRequestModelBase from '../_generated/modelBases/lookup-content-type-request-model-base';

export default class LookupContentTypeRequestModel extends LookupContentTypeRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
